import { fetchCartPrices, fetchTrialCartPrices, useSelector } from "@jti/store";
import useCurrentPrice from "../../hooks/useCurrentPrice";
import { useFreeTrial } from "../../hooks/useFreeTrial";
export const usePrice = (selectedOrderDetails, isStandardCheckoutFlow) => {
    const { isFreeTrial, freeTrialId } = useFreeTrial();
    const trialCartPrices = useSelector((state) => state.freeTrialCart.prices);
    const { id: cartId, prices: cartPrices } = useSelector((state) => state.cart);
    const prices = useCurrentPrice(isFreeTrial, isStandardCheckoutFlow, selectedOrderDetails);
    return {
        cartId: isFreeTrial ? freeTrialId : cartId,
        isFreeTrial,
        prices,
        pricesFetchStatus: isFreeTrial ? trialCartPrices.fetchStatus : cartPrices.fetchStatus,
        fetchCurrentPrices: isFreeTrial ? fetchTrialCartPrices : fetchCartPrices,
    };
};
//# sourceMappingURL=usePrice.js.map